import { combineReducers } from 'redux';
import { LoginResponse } from '../../dto/auth.dto';
export const SetAuth = 'SetAuth';
export const ActionsAuth = {
    SetAuthData(data: LoginResponse) {
        return { type: SetAuth, auth: data };
    }
}
const Auth = (state: any = {}, action: any) => {

    switch (action.type) {
        case SetAuth:
            state = action.auth;
            return state
        default:
            return state
    }
}
export const getAuth = (state: any) => {
  return  state.Auth;
}
export default combineReducers({
    Auth
});
